<div class="outer-container">

  <lib-title-bar [crumbs]="[{ 'label': 'Webhooks' }, { 'label': 'Configure' }]">
    @if (currentUserPermissions$ | async; as currentUserPermissions) {
      @if (hasCreatePermission(currentUserPermissions)) {
        <lib-action-button
          label="New Webhook" fontImage="far fa-plus-circle fa-bg" (click)="onClickCreate()">
        </lib-action-button>
      }
    }
  </lib-title-bar>

  <lib-table-base
    class="webhooks-table"
    [columnDefs]="webhookColumnDefs"
    [rowsData]="webhooks"
    [rowsDataLoading]="loading"
    [rowsDataError]="error"
    rowsDataErrorMessage="Error Loading Webhooks"
    selectedRowProperty="id"
    (rowSelected)="onRowSelected($event)">

    <ng-template let-element="element" let-columnId="columnId">
      <app-webhooks-table-cell-content
        [columnId]="columnId"
        [element]="element"
        [config]="config"
        [toggleWebhookLoading]="toggleWebhooksLoading.indexOf(element.id) !== -1"
        (activeToggled)="onIsActiveToggled($event)">
      </app-webhooks-table-cell-content>
    </ng-template>
  </lib-table-base>

</div>
